<!--<div class="box__input center" *ngIf="showFrameTraceUpload">-->
<!--  <input type="file" (change)="fileChanged($event)">-->
<!--  <p><strong>Choose frametrace to Upload</strong><span class="box__dragdrop"> or drag and drop them here</span>.</p>-->
<!--</div>-->
<div class="uploadfileBox">
  @if (showFrameTraceUpload) {
  <div class="uploadfilecontainer" ecpDragDrop (click)="fileInput.click()" (fileDropped)="fileChanged($event)">
    <input hidden type="file" #fileInput (change)="fileChanged($event)" />
    <div class="upload__label">
      <fa-icon class="icon" [icon]="['fas', 'cloud-upload-alt']"></fa-icon>
      <p>
        Drag & Drop files here <br />
        or
      </p>
      <button class="upload__button">Browse Files</button>
    </div>
  </div>
  }
</div>

<div id="preview-container">
  <div
    #previewModalBody
    id="preview-modal-body"
    [ngClass]="{ 'show-preview': !showFrameTraceUpload, 'hide-preview': showFrameTraceUpload }"
  ></div>
  <!--
  LensePreview requires these to exist, but they're not actually related to the lens preview.
  See compatibility.js for documentation on how to remove these
  -->
  <div hidden>
    <input id="framea" />
    <input id="frameb" />
    <input id="frameed" />
    <input id="framecircum" />
    <input id="framedbl" />
  </div>
  <!-- end -->
</div>
